export default __webpack_public_path__ + "static/media/howToCreateLightMode.e6acd067.svg";